import {
  GET_REPORT_TEMPLATES,
} from '../constants/actionTypes';

const initialState = {
  reportTemplates: [],
};

const reports = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_TEMPLATES:
      return {...state, reportTemplates: action.payload};
    default:
      return state;
  }
}

export default reports;



// WEBPACK FOOTER //
// ./src/reducers/reducer-reports.js